import toast from 'react-hot-toast';

// Get theme-appropriate styling
const getToastStyle = (borderColor?: string) => {
  const isDark = document.documentElement.classList.contains('dark');
  
  return {
    background: isDark ? 'rgba(25, 25, 25, 0.95)' : 'rgba(255, 255, 255, 0.95)',
    color: isDark ? '#f3f4f6' : '#1f2937',
    border: `1px solid ${borderColor || (isDark ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.1)')}`,
    borderRadius: '0.5rem',
    backdropFilter: 'blur(16px)',
    boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
  };
};

// Custom toast functions with consistent styling
export const showToast = {
  success: (message: string, duration: number = 4000) => {
    return toast.success(message, {
      duration,
      style: getToastStyle('rgba(16, 185, 129, 0.2)'),
      iconTheme: {
        primary: '#10b981',
        secondary: '#ffffff',
      },
    });
  },
  
  error: (message: string, duration: number = 5000) => {
    return toast.error(message, {
      duration,
      style: getToastStyle('rgba(239, 68, 68, 0.2)'),
      iconTheme: {
        primary: '#ef4444',
        secondary: '#ffffff',
      },
    });
  },
  
  warning: (message: string, duration: number = 4500) => {
    return toast(message, {
      icon: '⚠️',
      duration,
      style: getToastStyle('rgba(245, 158, 11, 0.2)'),
    });
  },
  
  loading: (message: string) => {
    return toast.loading(message, {
      style: getToastStyle(),
    });
  },
  
  info: (message: string, duration: number = 4000) => {
    return toast(message, {
      icon: 'ℹ️',
      duration,
      style: getToastStyle('rgba(59, 130, 246, 0.2)'),
    });
  },
};
